export enum LimbAlignment {
    UpperLimb = 'upperLimb',
    Center = 'center',
    LowerLimb = 'lowerLimb',
}
